import React from 'react';
import { TextV2, LinkV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

const TERMS_URL = 'https://withjoy.com/eula';
const PRIVACY_POLICY_URL = 'https://privacy.withjoy.com';

type TermsAndConditionsProps = Readonly<{
  buttonLabel: string;
}>;

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ buttonLabel }) => {
  const { tq } = useTranslation('contactCollector');

  return (
    <TextV2
      typographyVariant="label1"
      marginTop="16px"
      width="100%"
    >
      {tq`By clicking "${buttonLabel}", you agree to receive event updates from the host via SMS or email. Msg & data rates may apply. Reply STOP to opt out.`}{' '}
      <LinkV2
        typographyVariant="label1"
        href={TERMS_URL}
        textDecoration="none"
        color="newUIBrandPrimary"
        target="_blank"
      >
        {tq`Terms`}
      </LinkV2>
      {' & '}
      <LinkV2
        typographyVariant="label1"
        href={PRIVACY_POLICY_URL}
        textDecoration="none"
        color="newUIBrandPrimary"
        target="_blank"
      >
        {tq`Privacy Policy`}
      </LinkV2>
    </TextV2>
  );
};
